import UnimakeApiService from '../UnimakeApiService';

export default class PedidoService {
    private unimakeApi: UnimakeApiService;
    private path: string = '/Loja/Pedido';
    
    constructor() {
        this.unimakeApi = new UnimakeApiService();
    }

    /**     
     * Adiciona um item ao carrinho/cria o pedido
     * @param IdProduto Id do produto
     * @param IdCliente Id do cliente
     * @param Quantidade Quantidade a ser adicionada
     */
    public async Comprar(IdProduto: number, Quantidade: number): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {            
                let headers = {
                    'Authorization': localStorage.getItem('TokenUsuario')
                }
                let idPedido = localStorage.getItem('OrderID');
                let body = {
                    'idpedido': idPedido,
                    'idproduto': IdProduto,
                    'quantidade': Quantidade
                };

                let response = await this.unimakeApi.post(`${this.path}/CreateOrder`, body, headers);

                resolve(response);
            }
            catch(error) {
                reject(error);
            }
        });
    }

    //!Possiveis campos: ticket, cupom, idrenova
    public async Fechar(IdPedido: any, IdRenova: any, EmailFat: string): Promise<any> {
        return new Promise(async (resolve, reject) => {
            try {
                let headers = {
                    'Authorization': localStorage.getItem('TokenUsuario')
                }           
                let body = {
                    'idpedido': IdPedido,
                    'idrenova': !IdRenova ? null : IdRenova,
                    'email_fat': EmailFat
                };

                let response = await this.unimakeApi.post(`${this.path}/Fechar`, body, headers);

                resolve(response);
            }
            catch(error) {
                reject(error);
            }
        });
    }
}
